// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-block__container{min-height:40px;display:flex;flex-direction:row;justify-content:space-between;align-items:center}.title-block__share-button{align-self:flex-start;color:var(--ion-color-secondary);position:relative;width:108px}.title-block h1{display:inline-block;margin:0;font-size:28px;color:#fff}.title-block .text-muted,.title-block h2{font-size:20px;color:#b9bdcc;text-shadow:0 1px 0 #000}.title-block h3{font-size:19px;font-weight:100;margin-bottom:15px;margin-top:0}", ""]);
// Exports
module.exports = exports;
